import { AUTH_ERRORS, AUTH_ERRORS_EN } from "@libs/constants/errors.const";

export class AuthError extends Error {

    private lang: string = 'br';

    constructor(error: any, lang: string = 'br') {
        super(error.message);

        this.lang = lang;
        this.message = this.getMessage(error);
        this.name = 'AuthError';
    }
    
    getMessage(error: any) {
        const errors = [error?.code, error?.message, error.error?.code, error];
        const auth_errors = this.lang == 'br' ? AUTH_ERRORS : AUTH_ERRORS_EN;
        let errorMessage = this.lang == 'br' ? 'Ocorreu um erro desconhecido.' : 'An unknown error occurred.';

        const matchingError = errors.find((error) => auth_errors[error]);
        if (matchingError) errorMessage = auth_errors[matchingError];

        return errorMessage;
    }
}
